


































































































import { HtmlModal, Scrollbar } from '@/app/components';
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
    name: 'Terms',
    components: { HtmlModal, Scrollbar },
});
